import { useState, useEffect } from "react";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

const ClientTypeSelection = ({ formData, handleChange, action = "ajout" }) => {
  const [typeClient, setTypeClient] = useState(formData?.typeClient || "particulier");

  useEffect(() => {
    if (action === "modification") {
      setTypeClient(
        formData.cat_cli_code === "00" ? "particulier" : "entreprise"
      );
    }
  }, [formData.cat_cli_code, action]);

  const handleSelectionChange = (e) => {
    const newValue = e.target.value;
    setTypeClient(newValue);
    if(action === "modification") {
      const cat_cli_code = newValue === "particulier" ? "00" : "02";
      handleChange("cat_cli_code",cat_cli_code ); 
    } else {
      handleChange("typeClient", newValue);
    }
  };

  return (
    <div className="flex justify-center h-32 items-center">
      <FormControl>
        <RadioGroup
          row
          value={typeClient}
          name="type-client"
          onChange={handleSelectionChange}
        >
          <FormControlLabel
            value="particulier"
            control={<Radio />}
            label="Particulier"
          />
          <FormControlLabel
            value="entreprise"
            control={<Radio />}
            label="Entreprise"
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default ClientTypeSelection;
